import ImagePlaceholderIcon from "../icons/image-placeholder-icon"

const ImagePlaceholder = () => {
  return (
    <div className="flex items-center justify-center w-full h-full rounded-soft bg-grey-5">
      <ImagePlaceholderIcon size={12} />
    </div>
  )
}

export default ImagePlaceholder
